<template>
    <section>
        <div class="ask_section1" style="display: flex; flex-direction: column; justify-content: flex-end; position: relative; ">
            <div class="con_wrap" style="height: 60%; display: flex; flex-direction: column; align-items: flex-start; padding-top: 210px; margin-bottom: 15px;">
                <p data-aos="fade-up"
                    data-aos-delay="0"
                    data-aos-once="true"
                    data-aos-duration="600"
                    data-aos-easing="ease-in-out" style="font-size: 50px; font-weight: 300; text-align: left; margin-bottom: 45px;">
                    제안 및 사업 문의
                </p>
                <p data-aos="fade-up"
                    data-aos-delay="0"
                    data-aos-once="true"
                    data-aos-duration="600"
                    data-aos-easing="ease-in-out" style="font-size: 30px; font-weight: 400; text-align: left;">
                    안녕하세요 필드유입니다.<br>
                    제안 및 사업 문의는 언제든지 연락주세요.
                </p>
            </div>
            <img src="@/assets/images/main_v2/background_section4.svg" alt="" style="width: 100%">
        </div>
    </section>
</template>
<script>
import { ChevronDownIcon } from 'vue-feather-icons'
export default {
    components: {
        ChevronDownIcon
    }
    
}
</script>
<style>
    .ask_section1 {
        width: 100vw;
        height: 100vh;
        object-fit: inherit;
    }
</style>